/* eslint import/prefer-default-export: 0 */

const lazyCmpConfig = {
  loading: {
    template: "<div>Async loading!</div>"
  },
  error: {
    template: "<div>ERROR loading!</div>"
  },
  delay: 200,
  timeout: 10000
};

export const CompanyAdminSection = () => ({
  component: import("@/companyAdmin/components/layout/CompanyAdminSection"),
  ...lazyCmpConfig
});

export const Dashboard = () => ({
  component: import("@/companyAdmin/components/pages/Dashboard"),
  ...lazyCmpConfig
});

export const UserList = () => ({
  component: import("@/companyAdmin/components/pages/UserList"),
  ...lazyCmpConfig
});

export const CreateUser = () => ({
  component: import("@/companyAdmin/components/pages/CreateUser"),
  ...lazyCmpConfig
});

export const ImportUsers = () => ({
  component: import("@/companyAdmin/components/pages/ImportUsers"),
  ...lazyCmpConfig
});

export const CreateGroup = () => ({
  component: import("@/companyAdmin/components/pages/CreateGroup"),
  ...lazyCmpConfig
});

export const EditGroup = () => ({
  component: import("@/companyAdmin/components/pages/EditGroup"),
  ...lazyCmpConfig
});

export const EditUser = () => ({
  component: import("@/companyAdmin/components/pages/EditUser"),
  ...lazyCmpConfig
});

export const PermissionIndex = () => ({
  component: import("@/companyAdmin/components/pages/PermissionIndex"),
  ...lazyCmpConfig
});
